import { render, staticRenderFns } from "./CellRendererPlaceActions.vue?vue&type=template&id=1457d7b6"
import script from "./CellRendererPlaceActions.vue?vue&type=script&lang=js"
export * from "./CellRendererPlaceActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports